import React from "react";
import { PeopleCommunity20Filled, Document20Regular, Eye20Regular } from "@fluentui/react-icons";
import { Button, Title1 } from "@fluentui/react-components";
import { Col } from "../components/Layout/Space";
import { navigate } from "../utils";
import "./HelpPage.scss";

export const COMMUNITY_URL = "https://forum.anaconda.com/c/python-in-excel/anaconda-toolbox";
const DOCS_URL = "https://anaconda.com/docs/tools/excel/toolbox/";

export const HelpPage = () => {
  const margin = { marginRight: 3 };
  return (
    <div>
      <div style={{ marginBottom: 12 }}>
        <Title1 style={{ fontWeight: 600, fontSize: 16 }}>Help</Title1>
      </div>
      <Col gap={12}>
        <Button
          className="feedback-button"
          icon={<Document20Regular style={margin} />}
          onClick={() => navigate(DOCS_URL)}
        >
          Documentation
        </Button>
        <Button
          className="feedback-button"
          icon={<PeopleCommunity20Filled style={margin} />}
          onClick={() => navigate(COMMUNITY_URL)}
        >
          Community Forums
        </Button>
        <Button className="feedback-button" icon={<Eye20Regular style={margin} />}>
          <a
            style={{ textDecoration: "none", color: "inherit" }}
            href="https://legal.anaconda.com/policies/en/?name=privacy-policy"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </Button>
      </Col>
    </div>
  );
};
